module.exports = __webpack_public_path__ + "img/resource-img2.2c18fbf0.jpg";